import { SET_SEARCH_CODE } from './types';

export const setSearchCode = (searchCode) => ({
  type: SET_SEARCH_CODE,
  payload: searchCode,
});
